import { PlusIcon } from "lucide-react";

import { Link } from "@/components/Link";
import { Text } from "@/components/ui/text";
import type { Panel } from "../../types";
import { currencyFormatter } from "../../utils/currency";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function PanelsTable({ panels }: { panels?: Panel[] }) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "panels",
    panels,
    [
      {
        field: "name",
        headerName: "Name",
        flex: 2,
        minWidth: 200,
        // cellRenderer: (params) => (
        //   <Link to={`${params.id}/edit`}>{params.name}</Link>
        // ),
        cellRenderer: "agGroupCellRenderer",
        cellRendererParams: (params) => ({
          innerRenderer: (params) => (
            <Link to="/admin/panels/$id/edit" params={{ id: params.id }}>
              {params.name}
            </Link>
          ),
          innerRendererParams: {
            name: params.data.name,
            id: params.data.id,
          },
        }),
      },
      {
        field: "code",
        width: 96,
        minWidth: 72,
        maxWidth: 112,
      },
      {
        field: "description",
        headerName: "Description",
        flex: 3,
        minWidth: 220,
      },
      {
        field: "enabled",
        headerName: "Enabled",
        width: 128,
        minWidth: 118,
        filter: "agSetColumnFilter",
      },
      {
        field: "price",
        headerName: "Price",
        width: 108,
        minWidth: 96,
        maxWidth: 128,
        type: "rightAligned",
        filter: "agNumberColumnFilter",
        cellRenderer: (params) => (
          <Text isDanger={params.value === 0}>
            {currencyFormatter(params.value)}
          </Text>
        ),
        valueGetter: (params) => params.data?.price?.toNumber() ?? 0,
      },
    ],
    {
      masterDetail: true,
      detailCellRendererParams: {
        detailGridOptions: {
          columnDefs: [
            {
              field: "name",
              flex: 1,
              minWidth: 160,
              cellRenderer: ({ data }) => {
                return (
                  <Link to="/admin/tests/$id/edit" params={{ id: data.id }}>
                    {data.name}
                  </Link>
                );
              },
            },
            {
              field: "code",
              width: 100,
              minWidth: 72,
              maxWidth: 140,
            },
            {
              field: "type",
              width: 120,
              minWidth: 88,
              maxWidth: 180,
            },
          ],
        },
        getDetailRowData: (params) => {
          params.successCallback(params.data?.tests ?? []);
        },
      },
    },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/panels/new" asButton>
          <PlusIcon data-slot="icon" /> Add panel
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
